module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_60.ffaf750a.png";